import { IApplicationState } from '../types/redux';

export const offersSelector = (state: IApplicationState) => {
  return state.newbuilding.stats;
};
